const LoginFullNameValidations = (values) => {
  const errors = {};
  if (!values.first_name) {
    errors.first_name = "Requerido";
  }

  if (!values.last_name) {
    errors.last_name = "Requerido";
  }

  return errors;
};

export const required = (value) => (value ? undefined : "Requerido");

export default LoginFullNameValidations;
